export default class NewsletterSignupController {
    static createRequestHandler({
        uid = '',
        formId = `SubscriptionForm${uid}`,
        errorId = `subscription-errormessage${uid}`,
        successId = `subscription-successmessage${uid}`,
    } = {}) {
        return function onSubscriptionRequest(result) {
            const form = document.getElementById(formId);
            const errorMessage = document.getElementById(errorId);
            const successMessage = document.getElementById(successId);

            if (form) {
                form.classList.remove('was-validated');
            }

            if (result.success) {
                form?.reset();
                errorMessage?.classList.add('d-none');
                successMessage?.classList.remove('d-none');
            } else {
                errorMessage?.classList.remove('d-none');
                successMessage?.classList.add('d-none');
            }
        };
    }

    static initMailchimpForm({
        submitLabel = 'Submit',
        placeholder = 'Email',
        label = 'Subscribe',
        btnClass = 'btn btn-primary',
    } = {}) {
        // Button
        const btn = document.getElementById('mc-embedded-subscribe');

        if (btn) {
            btn.classList.add(...btnClass.split(' '));
            btn.value = submitLabel;
        }

        // Email input
        const emailInput = document.querySelector('#mc_embed_signup_scroll > input[type="email"]');

        if (emailInput) {
            emailInput.placeholder = placeholder;
            emailInput.classList.add('form-control');
        }

        // Label
        const lbl = document.querySelector('#mc_embed_signup_scroll > label');

        if (lbl) {
            lbl.classList.add('d-flex', 'justify-content-center', 'justify-content-lg-end', 'subheader');
            lbl.textContent = label;
        }
    }
}
